<!--
무자료확인(스캔) > 메인 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
        <!-- 상단헤더 영역 -->
        <layout-header
            :region-id="regionId"
            :scan="scan"
        >
        </layout-header>


        <!-- 컨텐츠 영역 -->
        <div class="uk-height-1-1 uk-overflow-auto">
            <scan
                class=""
                ref="scan"
                :csrf-token="csrfToken"
                :region-id="regionId"
                :scan="scan"
                :nodata-overdays-from-shipin="nodataOverdaysFromShipin"

                v-on:update:scan="scanListener($event)"
            >
            </scan>
        </div>

        <!-- 하단푸터 영역-->
        <layout-footer
            :region-id="regionId"
            :login-user-name="loginUserName"
            :nodata-overdays-from-shipin="nodataOverdaysFromShipin"
            v-on:update:nodataOverdaysFromShipin="nodataOverdaysFromShipinListener($event)"
        >
        </layout-footer>

        <!-- 사운드 -->
        <audio controls="controls">
            <source src="/ship-in-sound/normal.mp3" type="audio/mpeg" />
            Your browser does not support the audio element.
        </audio>

    </div>
</template>

<script>

    export default {
        components: {
            'scan': require('./scan.vue').default,
            'layout-header': require('./layout-header.vue').default,
            'layout-footer': require('./layout-footer.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

        },
        data: function () {
            /**
             * 무자료등록 기준일 쿠키값
             */
            let nodata_overdays_from_shipin = Cookies.get('nodata-overdays-from-shipin');
            if (! nodata_overdays_from_shipin) {
                nodata_overdays_from_shipin = 3;
            } else {
                nodata_overdays_from_shipin = parseInt(nodata_overdays_from_shipin);
            }

            return {

                /**
                 * (object) 현재 스캔된 정보
                 *  - ShipIn object
                 */
                scan: null,

                /**
                 * 사운드
                 * https://soundoftext.com/
                 **/
                sound: {
                    normal: null,
                    multi: null,
                    nodata: null,
                    urgent: null,
                    slow_work: null,
                    multi_tracking: null,
                },

                /**
                 * (int) 무자료등록 기준일
                 * 현재 스캔된 무자료가 설정된 기준일을 초과했을경우, 무자료등록 안내처리
                 */
                nodataOverdaysFromShipin: nodata_overdays_from_shipin,

            };
        },
        mounted: function () {
            // 사운드 preload
            this.sound.normal = new Audio('/ship-in-sound/normal.mp3');
            //this.sound.urgent = new Audio('/ship-in-sound/urgent-box.mp3');
            this.sound.multi = new Audio('/ship-in-sound/multi-match-ko.mp3');
            this.sound.nodata = new Audio('/ship-in-sound/nodata-box.mp3');
            this.sound.register_nodata = new Audio('/ship-in-sound/register-nodata-ko.mp3');
            //this.sound.slow_work = new Audio('/ship-in-sound/slow-work.mp3');
            //this.sound.multi_tracking = new Audio('/ship-in-sound/multi-tracking.mp3');
        },
        computed: {

        },
        methods: {
            /**
             * 스캔 이벤트 리스너
             * @param scan (object)이벤트 전달값
             */
            scanListener: function (scan) {
                // 스캔 결과 저장
                this.scan = scan;

                // 소리
                if (this.scan.trackings.length === 1) {
                    this.sound.normal.play();
                } else if (scan.trackings.length > 1) {
                    this.sound.multi.play();
                } else if (scan.trackings.length === 0) {
                    if (this.$refs.scan.getNeedRegisterNodata(scan)) {
                        // 무자료등록 안내
                        this.sound.register_nodata.play();
                    } else {
                        // 아직 등록기준일 초과되지 않은 무자료
                        this.sound.nodata.play();
                    }

                }

                this.showScan();

            },

            /**
             * 스캔화면으로 전환
             */
            showScan: function () {

                // 포커싱
                this.$nextTick(() => {
                    this.$refs.scan.focus();
                });

            },

            /**
             * 무자료등록 기준일 리스너
             * @param value 무자료등록 기준일
             */
            nodataOverdaysFromShipinListener: function (value) {
                //console.log(mode);
                Cookies.set('nodata-overdays-from-shipin', value, { expires: 365 });
                this.nodataOverdaysFromShipin = value;
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>